import React, { useState, useEffect } from "react";
import "../styles/Socials.css";

const Socials = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show socials after a small delay for smooth entrance
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  const socialLinks = [
    {
      name: "YouTube",
      url: "https://www.youtube.com/@Spardhaweb",
      icon: "https://cdn-icons-png.flaticon.com/512/1384/1384060.png",
      color: "#FF0000",
      hoverColor: "#CC0000"
    },
    {
      name: "Telegram",
      url: "https://t.me/+BdSatS5bmdE5ODQ1",
      icon: "https://cdn-icons-png.flaticon.com/512/2111/2111646.png",
      color: "#0088cc",
      hoverColor: "#006699"
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/mpsc_insta?igsh=MWtobmFudjk1OGxndA==",
      icon: "https://cdn-icons-png.flaticon.com/512/2111/2111463.png",
      color: "#E4405F",
      hoverColor: "#C13584"
    },
    {
      name: "WhatsApp",
      url: "https://whatsapp.com/channel/0029VacaEMFInlqSAA9ilQ1f",
      icon: "https://cdn-icons-png.flaticon.com/512/733/733585.png",
      color: "#25D366",
      hoverColor: "#1DA851"
    }
  ];

  return (
    <div className={`socials-container ${isVisible ? 'visible' : ''}`}>
      <ul className="socials-list">
        {socialLinks.map((social, index) => (
          <li 
            key={social.name} 
            className="social-item"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <a
              className="social-link"
              href={social.url}
              role="button"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit our ${social.name}`}
              title={social.name}
              style={{
                '--hover-color': social.hoverColor
              }}
            >
              <img
                src={social.icon}
                alt={`${social.name} icon`}
                width="30"
                height="30"
                className="social-icon"
                loading="lazy"
              />
              <span className="social-tooltip">{social.name}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Socials;